module.exports = __webpack_public_path__ + "img/doc-dibbling@2x.b274f803.png";